import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { cameraCenter, CameraMode } from "@stellar-globe/stellar-globe"
import { readHashState } from "../../store/stateSync/hashSync"
import { readStorageState } from "../../store/stateSync/StorageSync"


export type CameraParams = Record<'theta' | 'phi' | 'roll' | 'za' | 'zd' | 'zp' | 'fovy', number>


type State = {
  projection: CameraMode
  retina: boolean
  pointerLockInvertX: boolean
  pointerLockInvertY: boolean
  params: CameraParams
}


const initialCameraParams: CameraParams = {
  fovy: 2,
  theta: 0,
  phi: 0,
  roll: 0,
  za: 0,
  zd: Math.PI / 2,
  zp: 0,
}


function initialState(): State {
  const hashState = readHashState()
  const storageState = readStorageState()
  return {
    retina: storageState.retina ?? false,
    pointerLockInvertX: storageState.pointerLockInvertX ?? false,
    pointerLockInvertY: storageState.pointerLockInvertY ?? false,
    projection: hashState.projection ?? storageState.projection ?? 'STEREOGRAPHIC',
    params: hashState.cameraParams ?? storageState.cameraParams ?? initialCameraParams,
  }
}


export const cameraSlice = createSlice({
  name: 'camera',
  initialState,
  reducers: {
    projectionUpdated(state, { payload: projection }: PayloadAction<CameraMode>) {
      state.projection = projection
    },
    retinaToggled(state) {
      state.retina = !state.retina
    },
    pointerLockInvertXToggled(state) {
      state.pointerLockInvertX = !state.pointerLockInvertX
    },
    pointerLockInvertYToggled(state) {
      state.pointerLockInvertY = !state.pointerLockInvertY
    },
    paramsChanged(state, { payload: params }: PayloadAction<CameraParams>) {
      state.params = params
    },
  },
  selectors: {
    center: createSelector(
      [
        (state: State) => state.params,
      ],
      params => cameraCenter(params),
    ),
  }
})
